import styles from "../../../styles/races/national/TaleOfTheTapeInfoItem.module.scss";

const TaleOfTheTapeInfoItem =({
  item
}) => {
  return (
    <div className={styles.infoItem}>
      {item.label && <div className={styles.label}>{item.label}</div>}
      {item.content && <div className={styles.content}>
          <p
            className={styles.candidateDesc}
            dangerouslySetInnerHTML={{ __html: item.content}}
          />
        </div>
      }
    </div>
  );
}

export default TaleOfTheTapeInfoItem;